import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Seo, SITE } from "../components/Seo";
import { Footer } from "../components/Footer";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Blog = () => {
  const [posts, setPosts] = useState(null);
  useEffect(() => {
    axios.get(`${API}/posts`).then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, []);

  return (
    <>
      <Seo
        title="Nexus Numbers Blog | Paystub & Proof-of-Income Guides"
        description="Guides on paystubs, earnings statements and proof of income for gig, 1099 and self-employed workers."
        canonicalPath="/blog"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Nexus Numbers Blog",
          url: `${SITE}/blog`,
        }}
      />
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-14 min-h-[50vh]">
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0F172A]">
          Nexus Numbers Blog
        </h1>
        <p className="mt-3 text-[#475569]">Practical guides on documenting real income.</p>

        {posts === null ? (
          <div className="flex items-center gap-2 text-[#64748B] mt-10">
            <Loader2 className="w-4 h-4 animate-spin" /> Loading posts…
          </div>
        ) : posts.length === 0 ? (
          <p className="mt-10 text-[#64748B]">No posts published yet. Check back soon.</p>
        ) : (
          <div className="mt-8 space-y-5">
            {posts.map((p) => (
              <Link
                key={p.id}
                to={`/blog/${p.slug}`}
                data-testid={`blog-item-${p.slug}`}
                className="block rounded-xl border border-[#D0E2FF] bg-white p-6 hover:shadow-md hover:border-[#A6C8FF] transition-all"
              >
                <div className="text-xs text-[#94A3B8] mb-1">{p.publishDate}</div>
                <h2 className="font-display text-xl font-semibold text-[#0F172A]">{p.title}</h2>
                <p className="text-sm text-[#475569] mt-2">{p.metaDescription}</p>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </>
  );
};
